<div class="modal-body">
  <div class="modal-header">
    <button type="button" class="close close-icon" aria-label="Close"
            (click)="modal.close('Cross click')">
    </button>
  </div>
  <div class="modal-body">
    <h1>How are copays determined?</h1>
    <p>Copays are determined by your insurance plan. You'll pay a 30-day copay for each of your medications.</p>
    <p class="mt-15">Drugs costs may change when prescriptions are transferred to a new pharmacy or change from a 90-day prescription to a 30-day cycle.
      To align prescriptions on a 30-day cycle, one or more additional copays may be required by the patient`s plan.
    </p>
    <p class="mt-15">Medications enrolled in SimpleDose&trade; packs are processed and filled on the same day. Any copays
      will be due on the day of shipment, or when you pick up at the your local CVS Pharmacy.
    </p>
    <p class="mt-15">Have questions about your copay? Contact our customer care team at <strong><a href="tel:18007530596">1-800-753-0596</a></strong></p>
  </div>
</div>

